import { render, staticRenderFns } from "./BaseContainer.vue?vue&type=template&id=0e497f2a&scoped=true"
import script from "./BaseContainer.vue?vue&type=script&lang=js"
export * from "./BaseContainer.vue?vue&type=script&lang=js"
import style0 from "./BaseContainer.vue?vue&type=style&index=0&id=0e497f2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e497f2a",
  null
  
)

export default component.exports